import { useContext } from "react";
import { CreateActionContext } from "./CreateActionContext";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import init from "@beeldit/core/services/init";

function useInitialize() {
  const { setElement, setShowModal } = useContext(CreateActionContext);
  const errorHandler = useErrorHandler();
  return (formDefaultValues: any) => {
    init(
      "event_sessions",
      "?appends=prices&event_id=" + formDefaultValues.event_id
    )
      .then((response: any) => {
        let data = response.data;
        setElement({
          ...data,
          ...formDefaultValues,
        });
        setShowModal(true);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useInitialize;
